export const MainNav = [

  {
    icon: "pe-7s-cart",
    label: "Cart",
    to: "#/cart",
  },
  {
    icon: "pe-7s-rocket",
    label: "Dashboard",
    to: "#/dashboard",
  },
 
 
];

export const AddRecords = [
  {
    icon: "pe-7s-browser",
    label: "AI Machine Learn Lists",
    accessTo: "staff",
    to: "#/AI-Lists",
  },
  {
    icon: "pe-7s-browser",
    label: "Chat Gpt",
    accessTo: "staff",
    to: "#/chat-gpt",
  },
  {
    icon: "pe-7s-note",
    label: "List Creation",
    // accessTo: "staff",
    content: [
      {
        label: "Create List",
        to: "#/lists/create-list",
      },
      {
        label: "Saved Lists",
        to: "#/lists/saved-lists",
      },
    
    ],
  },
  {
    icon: "pe-7s-note2",
    label: "Leads Creation",
    content: [
      {
        label: "Probate",
        to: "#/leads/Probate",
      },
      {
        label: "FirstUp",
        to: "#/leads/FirstUp",
      },
      {
        label: "Preforeclosure",
        to: "#/leads/Preforeclosure",
      },
      {
        label: "FSBO",
        to: "#/leads/FSBO",
      },
      {
        label: "FRBO",
        to: "#/leads/FRBO",
      },
      {
        label: "FRBA",
        to: "#/leads/FRBA",
      },
      {
        label: "ML List",
        to: "#/leads/ML-List",
      },
      
    
    ],
  },
  {
    icon: "pe-7s-file",
    label: "Skip Tracing",
    content: [
      {
        label: "Single Skip",
        to: "#/skipTrace/single-skip",
      },
      {
        label: "Upload File",
        to: "#/skipTrace/upload-file",
      },
      {
        label: "Uploaded Files",
        to: "#/skipTrace/uploaded-files",
      },
    
    ],
  },
  {
    icon: "pe-7s-file",
    label: "LeadScrubber ™",
    to: "#/scrubbing-system/upload-file/",
  },
  
  {
    icon: "pe-7s-cloud-upload",
    label: "Upload File",
    accessTo: "staff",
    to: "#/upload-file",
  },

]

export const Marketing = [
  {
    icon: 'pe-7s-headphones',
    label: "AI Chat Bot",
    content: [
      {
        label: "SetUp",
        to: "#/marketing",
      },
      {
        label: "Conversations",
        to: "#/marketing/chat",
      },
    ]
  },
  // {
  //   icon: "pe-7s-note",
  //   label: "Lists",
  //   content: [
  //     {
  //       label: "Conversations",
  //       to: "#/marketing/chat",
  //     },    
  //   ],
  // },
]

export const Tools =[
  {
    icon: "pe-7s-id",
    label: "Customer Care",
    to: "#/customer-care",
  },
  {
    icon: "pe-7s-airplay",
    label: "P-Portal",
    to: "#/partnership-portal",
  },
  {
    icon: "pe-7s-id",
    label: "Admin Site",
    to: "https://leadfuzionlists.com/goto/my/full/control/admin/",
  },
  {
    icon: "pe-7s-airplay",
    label: "Partnership Portal",
    to: "https://leadfuzionlists.com/dedicated/partnership/portal/",
  },
  {
    icon: "pe-7s-copy-file",
    label: "Payments Report",
    to: "https://leadfuzionlists.com/payments_report/",
  },
  {
    icon: "pe-7s-airplay",
    label: "Coupon System",
    to: "https://leadfuzionlists.com/coupon_system/coupon/",
  },
  {
    icon: "pe-7s-rocket",
    label: "Scraper Dashboard",
    to: "https://leadfuzionlists.com/scraper_dashboard/",
  },
  {
    icon: "pe-7s-browser",
    label: "Virtual Portal",
    to: "https://leadfuzionlists.com/virtual_portal/",
  },
  {
    icon: "pe-7s-airplay",
    label: "Affiliate Systems",
    to: "#/affiliate-systems",
  },
]


export const Account = [
  {
    icon: "pe-7s-config",
    label: "Settings",
    // accessTO: "staff",
    to: "#/settings",
  },
  {
    icon: "pe-7s-user",
    label: "User Roles",
    // accessTO: "staff",
    to: "#/roles-management",
  },
]
// export const ComponentsNav = [
//   {
//     icon: "pe-7s-diamond",
//     label: "Elements",
//     content: [
//       {
//         label: "Buttons",
//         content: [
//           {
//             label: "Standard",
//             to: "#/elements/buttons-standard",
//           },
//           {
//             label: "Pills",
//             to: "#/elements/buttons-pills",
//           },
//           {
//             label: "Square",
//             to: "#/elements/buttons-square",
//           },
//           {
//             label: "Shadow",
//             to: "#/elements/buttons-shadow",
//           },
//           {
//             label: "With Icons",
//             to: "#/elements/buttons-icons",
//           },
//         ],
//       },
//       {
//         label: "Dropdowns",
//         to: "#/elements/dropdowns",
//       },
//       {
//         label: "Icons",
//         to: "#/elements/icons",
//       },
//       {
//         label: "Badges",
//         to: "#/elements/badges-labels",
//       },
//       {
//         label: "Cards",
//         to: "#/elements/cards",
//       },
//       {
//         label: "Loading Indicators",
//         to: "#/elements/loaders",
//       },
//       {
//         label: "List Groups",
//         to: "#/elements/list-group",
//       },
//       {
//         label: "Navigation Menus",
//         to: "#/elements/navigation",
//       },
//       {
//         label: "Timeline",
//         to: "#/elements/timelines",
//       },
//       {
//         label: "Utilities",
//         to: "#/elements/utilities",
//       },
//       {
//         label: "Visibility Sensor",
//         to: "#/elements/visibility-sensor",
//       },
//     ],
//   },
//   {
//     icon: "pe-7s-car",
//     label: "Components",
//     content: [
//       {
//         label: "Tabs",
//         to: "#/components/tabs",
//       },
//       {
//         label: "Accordions",
//         to: "#/components/accordions",
//       },
//       {
//         label: "Notifications",
//         to: "#/components/notifications",
//       },
//       {
//         label: "Modals",
//         to: "#/components/modals",
//       },
//       {
//         label: "Loading Blockers",
//         to: "#/components/loading-blocks",
//       },
//       {
//         label: "Progress Bar",
//         to: "#/components/progress-bar",
//       },
//       {
//         label: "Tooltips & Popovers",
//         to: "#/components/tooltips-popovers",
//       },
//       {
//         label: "Carousel",
//         to: "#/components/carousel",
//       },
//       {
//         label: "Calendar",
//         to: "#/components/calendar",
//       },
//       {
//         label: "Pagination",
//         to: "#/components/pagination",
//       },
//       {
//         label: "Count Up",
//         to: "#/components/count-up",
//       },
//       {
//         label: "Sticky Elements",
//         to: "#/components/sticky-elements",
//       },
//       {
//         label: "Scrollable",
//         to: "#/components/scrollable-elements",
//       },
//       {
//         label: "Maps",
//         to: "#/components/maps",
//       },
//       {
//         label: "Ratings",
//         to: "#/components/ratings",
//       },
//       {
//         label: "Image Crop",
//         to: "#/components/image-crop",
//       },
//       {
//         label: "Guided Tours",
//         to: "#/components/guided-tours",
//       },
//     ],
//   },
//   {
//     icon: "pe-7s-display2",
//     label: "Tables",
//     content: [
//       {
//         label: "Data Tables",
//         content: [
//           {
//             label: "Basic",
//             to: "#/tables/data-tables",
//           },
//           {
//             label: "Fixed Header",
//             to: "#/tables/datatables-fixed-header",
//           },
//           {
//             label: "Selectable Rows",
//             to: "#/tables/datatables-selectable-rows",
//           },
//         ],
//       },
//       {
//         label: "Regular Tables",
//         to: "#/tables/regular-tables",
//       },
//     ],
//   },
// ];
// export const FormsNav = [
//   {
//     icon: "pe-7s-light",
//     label: "Elements",
//     content: [
//       {
//         label: "Controls",
//         to: "#/forms/controls",
//       },
//       {
//         label: "Layouts",
//         to: "#/forms/layouts",
//       },
//       {
//         label: "Validation",
//         to: "#/forms/validation",
//       },
//       {
//         label: "Wizards",
//         content: [
//           {
//             label: "Variation 1",
//             to: "#/forms/wizard-1",
//           },
//           {
//             label: "Variation 2",
//             to: "#/forms/wizard-2",
//           },
//           {
//             label: "Variation 3",
//             to: "#/forms/wizard-3",
//           },
//         ],
//       },
//       {
//         label: "Sticky Form Headers",
//         to: "#/forms/sticky-headers",
//       },
//     ],
//   },
//   {
//     icon: "pe-7s-joy",
//     label: "Widgets",
//     content: [
//       {
//         label: "Datepicker",
//         to: "#/forms/datepicker",
//       },
//       {
//         label: "Range Slider",
//         to: "#/forms/range-slider",
//       },
//       {
//         label: "Input Selects",
//         to: "#/forms/input-selects",
//       },
//       {
//         label: "Toggle Switch",
//         to: "#/forms/toggle-switch",
//       },
//       {
//         label: "Dropdowns",
//         to: "#/forms/dropdown",
//       },
//       {
//         label: "WYSIWYG Editor",
//         to: "#/forms/wysiwyg-editor",
//       },
//       {
//         label: "Input Mask",
//         to: "#/forms/input-mask",
//       },
//       {
//         label: "Typeahead",
//         to: "#/forms/typeahead",
//       },
//       {
//         label: "Clipboard",
//         to: "#/forms/clipboard",
//       },
//       {
//         label: "Textarea Autosize",
//         to: "#/forms/textarea-autosize",
//       },
//       {
//         label: "Number Spinners",
//         to: "#/forms/numberspinners",
//       },
//       {
//         label: "Color Picker",
//         to: "#/forms/color-picker",
//       },
//       {
//         label: "Dropzone",
//         to: "#/forms/dropzone",
//       },
//     ],
//   },
// ];
// export const WidgetsNav = [
//   // {
//   //   icon: "pe-7s-graph2",
//   //   label: "Chart Boxes",
//   //   content: [
//   //     {
//   //       label: "Variation 1",
//   //       to: "#/widgets/chart-boxes",
//   //     },
//   //     {
//   //       label: "Variation 2",
//   //       to: "#/widgets/chart-boxes-2",
//   //     },
//   //     {
//   //       label: "Variation 3",
//   //       to: "#/widgets/chart-boxes-3",
//   //     },
//   //   ],
//   // },
//   // {
//   //   icon: "pe-7s-id",
//   //   label: "Profile Boxes",
//   //   to: "#/widgets/profile-boxes",
//   // },
//   // {
//   //   icon: "pe-7s-display1",
//   //   label: "Content Boxes",
//   //   to: "#/widgets/content-boxes",
//   // },
// ];
// export const ChartsNav = [
//   {
//     icon: "pe-7s-graph2",
//     label: "ChartJS",
//     to: "#/charts/chartjs",
//   },
//   {
//     icon: "pe-7s-graph",
//     label: "Apex Charts",
//     to: "#/charts/apexcharts",
//   },
//   {
//     icon: "pe-7s-gleam",
//     label: "Gauges",
//     to: "#/charts/gauges",
//   },
//   {
//     icon: "pe-7s-graph1",
//     label: "Chart Sparklines 1",
//     to: "#/charts/sparklines-1",
//   },
//   {
//     icon: "pe-7s-edit",
//     label: "Chart Sparklines 2",
//     to: "#/charts/sparklines-2",
//   },
// ];


export const StatusComponent = [
  
 
  {
    icon: "pe-7s-users",
    label: "Records",
    to: "#/records",
  },
    
  {
    icon: "pe-7s-display2",
    label: "Property",
    content: [
      // {
      //   label: "List Stacking",
      //   to: "#/records/list-stacking",
      //   id:"1"
      // },
      // {
      //   label: "Marketing",
      //   to: "#/records/marketing",
      //   id:"2"
      // },
      // {
      //   label: "Leads",
      //   to: "#/records/leads",
      //   id:"3"
      // },
      // {
      //   label: "WholeSaling",
      //   to: "#/records/wholesaling",
      //   id: "4"
      // },
      // {
      //   label: "Acquired",
      //   to: "#/records/acquired",
      //   id: "6"
      // },
      // {
      //   label: "Fliping",
      //   to: "#/records/fliping",
      //   id: "5"
      // },
    ],
  },

];

